import React from 'react';
import qs from 'qs';

import { PROCESSOR_OPT_STATUS } from '../../constants/processors';
import { ANCHOR_VIEW } from '../../constants/apiUrls/apiUrls';
import callApi from '../../utils/callApi';
import './css/bootstrap.css';
import './css/Checkout.css';

import CheckoutMessage from './CheckoutMessage';


class CheckoutPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorFirstName: '',
      checkoutImage: null,
      loading: false,
      anchor: {},
    };
    this.queryParams = qs.parse(window.location.search, { ignoreQueryPrefix: true });
  }

  componentDidMount() {
    const {
      transactionId1,
      amount1,
      currency1,
      productType1,
      quantity1,
      opStatus,
      subCategory,
    } = this.queryParams;
    if (subCategory) {
      this.fetchAnchorsData(subCategory, opStatus);
    }

    if (
      window.ga &&
        opStatus === PROCESSOR_OPT_STATUS.SUCCESS &&
        !process.env.REACT_APP_DEV
    ) {
      window.ga('ecommerce:addTransaction', {
        'id': transactionId1,
        'revenue': amount1,
        'currency': currency1,
      });

      window.ga('ecommerce:addItem', {
        'id': transactionId1,
        'name': productType1,
        'price': amount1,
        'quantity': quantity1,
        'currency': currency1,
      });

      window.ga('ecommerce:send');
    }
  }

  toggleLoading = () => {
    this.setState((state) => {
      return { loading: !state.loading };
    });
  };

  fetchAnchorsData = (anchorId, status) => {
    const url = ANCHOR_VIEW.replace('{id}', encodeURIComponent(anchorId));

    callApi(url, 'get', {}, {}, {}, true, true).
      then((res) => {
        if (status === PROCESSOR_OPT_STATUS.SUCCESS && this.state.loading) {
          this.toggleLoading();
        }
        if (res.status === 200 && res.data) {
          const { checkoutImage, name } = res.data;
          const anchorFirstName = name && name.split(' ')[0];

          this.setState({ checkoutImage, anchorFirstName, anchor: res.data });
        }
      }).
      catch((error) => {
        this.toggleLoading();
        console.error(error);
      });
  };

  render() {
    const { user } = this.props;
    const { checkoutImage, anchorFirstName, loading, anchor } = this.state;
    const { purchaseId, transactionId1, opStatus, errorCode, errorMessage, renewal, productType1, processorId } = this.queryParams;

    return (
      <CheckoutMessage
        anchor={anchor}
        anchorFirstName={anchorFirstName}
        checkoutImage={checkoutImage}
        errorCode={errorCode}
        errorMessage={errorMessage}
        isRenewal={renewal}
        loading={loading}
        opStatus={opStatus}
        processorId={processorId}
        productType1={productType1}
        purchaseId={purchaseId}
        searchParams={window.location.search}
        transactionId={transactionId1}
        user={user}
      />
    );
  }
}

export default CheckoutPage;
